import moment from 'moment';
import 'moment-timezone';
import { isSameDay, SERVER_TIMEZONE } from '@ally/date-utils';
export default function getConfirmationMessage(_a) {
    var deliveryDate = _a.deliveryDate;
    var isImmediate = isSameDay(deliveryDate, moment.tz(SERVER_TIMEZONE));
    if (isImmediate)
        return 'You completed a transfer.';
    return 'You scheduled a transfer.';
}
//# sourceMappingURL=getConfirmationMessage.js.map